
export const getRegExpSwearWords = (swearWords) => { 
    if (swearWords.length === 0) return null
    const pattern = `(^|[^а-яёА-ЯЁa-zA-Z])(${swearWords.join('|')})($|[^а-яёА-ЯЁa-zA-Z])`;
    const regExpSwearWords = new RegExp(pattern, "gi");
    return regExpSwearWords
}